import { ReactNode } from 'react';

import { IsNotEmpty, IsString } from 'class-validator';

import {
  FilterText as TextFilter,
  FilterSelect as SelectFilter,
  FilterSearch as SearchFilter,
  FilterMultiple as MultipleFilter,
  FilterBool as BoolFilter,
  FilterTimeRange as TimeRangeFilter,
  FilterMultipleSearch as MultipleSearchFilter,
} from './gen/filter';

interface OptionBadge {
  title?: string;
  description?: string;
  color?: 'gray' | 'green' | 'orange' | 'red' | 'blue' | 'velvet';
  position?: 'left' | 'bottom';
}

interface Option {
  label: string;
  value: string;
  prefix?: string;
  disabled?: boolean;
  badge?: OptionBadge;
  tooltipText?: string | React.ReactElement;
  additionalText?: string;
  color?: 'gray' | 'darkgray' | 'green' | 'orange' | 'purple' | 'blue' | 'red';
  group?: string;
}

class BaseFilter {
  @IsNotEmpty()
  @IsString()
  key: string;

  @IsNotEmpty()
  @IsString()
  name: string;
}

export {
  BaseFilter,
  TextFilter,
  SelectFilter,
  MultipleFilter,
  BoolFilter,
  TimeRangeFilter,
  SearchFilter,
  MultipleSearchFilter,
};

export type CommonFilter = {
  fullWidth: boolean;
  width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12; // eslint-disable-line no-magic-numbers
  newLine?: boolean;
  twoLine?: boolean;
  minInputValueLength?: number;
  disabled?: boolean;
  clearable?: boolean;
  labelPlacement?: 'start' | 'end';
  tooltip?: string;
  renderOption?: (option: Option, value?: string | string[]) => ReactNode;
};

export type Filter = (
  | TextFilter
  | SelectFilter
  | SearchFilter
  | MultipleSearchFilter
  | MultipleFilter
  | BoolFilter
  | TimeRangeFilter
) &
  CommonFilter;

export type Dateable = { start?: Date | string; end?: Date | string };

type FilterValue = number | boolean | string | string[] | Dateable | undefined;

export type FilterType<T = FilterValue> = Record<string, T> & {
  preset_id?: string;
};

export interface FilterParams<T = FilterValue> {
  filters: FilterType<T>;
  offset?: number;
  limit?: number;
}
